const ITEMS = ["Beliefs", "Identity", "Why", "Message", "Market", "Offer", "Action"];

export default function Marquee() {
  return (
    <div
      data-testid="marquee-section"
      className="relative border-y border-cream/10 py-5 sm:py-7 overflow-hidden bg-coal/60"
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform w-max">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {ITEMS.map((item) => (
              <span key={`${dup}-${item}`} className="flex items-center">
                <span className="font-display font-bold uppercase tracking-tight text-2xl sm:text-4xl text-cream/25 px-6 sm:px-10">
                  {item}
                </span>
                <span className="text-lime text-lg sm:text-2xl">→</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
